import React from 'react';
import UserProfileProvider from './context';
import UserProfileContent from './user-profile-content';

type UserProfileModalProps = {
  show: boolean;
  closeModal: () => void;
  id: string;
};

const CSUserProfileSideModal = ({ show, closeModal, id }: UserProfileModalProps) => {
  return (
    <UserProfileProvider>
      <UserProfileContent show={show} closeModal={closeModal} id={id} />
    </UserProfileProvider>
  );
};

export default CSUserProfileSideModal;
